import React, { type ReactNode, Suspense } from "react";
import { CCProcessorConfigurationMap } from "./CCProcessorConfigurationMap";
import Loader from "components/loader";
import { CCProcessorConfigurationContext } from "helpers/online_ordering/payments/CCProcessorConfigurationContext";
import { useAdyenOLOPaymentAccess } from "hooks/online_ordering/payment/adyen/useAdyenOLOPaymentAccess";
import type { CCProcessor } from "types/payments/credit_card";
import type { OrderResponse } from "types/reducers/checkout_status";

export interface CreditCardFormContainerProps<
  T extends OrderResponse = OrderResponse,
> {
  orderResponse?: T;
  children?: ReactNode;
}

export const CreditCardFormContainer = <T extends OrderResponse>(
  props: CreditCardFormContainerProps<T>
) => {
  const { data: isAdyenEnabled } = useAdyenOLOPaymentAccess();
  if (isAdyenEnabled === undefined) {
    return <Loader />;
  }
  const ccProcessor: CCProcessor = isAdyenEnabled ? "adyen" : "firstData";
  const ccProcessorConfiguration = CCProcessorConfigurationMap[ccProcessor];

  const ContainerImplementation = ccProcessorConfiguration.formContainer;

  return (
    <CCProcessorConfigurationContext.Provider value={ccProcessorConfiguration}>
      <Suspense fallback={<Loader />}>
        <ContainerImplementation {...props} />
      </Suspense>
    </CCProcessorConfigurationContext.Provider>
  );
};
